import classNames from "classnames"

import ImageBlock from "./ImageBlock"
import type { ImageGridItem, ImageGridRatioMode, ImageGridViewport } from "./types"

export type { ImageGridItem, ImageGridRatioMode, ImageGridViewport } from "./types"

export interface ImageGridProps {
  /** 1～3 张；未传或空数组时不渲染 */
  items?: ImageGridItem[]
  /** 默认 square */
  ratioMode?: ImageGridRatioMode
  /** Adapt 在 desktop / mobile 下行为不同 */
  viewport?: ImageGridViewport
  /** 与 Style 中 Corner radius 一致的圆角类名（如 rounded-lg） */
  cornerRadiusClass: string
}

const gridColsClass = (count: number, viewport: ImageGridViewport) => {
  if (viewport === "mobile") {
    return "grid-cols-1"
  }
  if (count <= 1) {
    return "grid-cols-1"
  }
  if (count === 2) {
    return "grid-cols-2"
  }
  return "grid-cols-3"
}

const ImageGrid = ({
  items: itemsProp,
  ratioMode = "SQUARE",
  viewport = "desktop",
  cornerRadiusClass,
}: ImageGridProps) => {
  const resolvedItems = itemsProp ?? []

  if (resolvedItems.length === 0) {
    return null
  }

  const count = Math.min(3, resolvedItems.length)
  const visibleItems = resolvedItems.slice(0, count)

  const isAdaptDesktop = ratioMode === "AUTO" && viewport === "desktop"

  return (
    <div className={classNames("grid w-full gap-5", gridColsClass(count, viewport))}>
      {visibleItems.map((item, index) => (
        <div
          key={item.src ? `${item.src}-${String(index)}` : `image-slot-${String(index)}`}
          className={classNames("min-w-0", isAdaptDesktop && "h-full min-h-0")}
        >
          <ImageBlock
            cornerRadiusClass={cornerRadiusClass}
            item={item}
            ratioMode={ratioMode}
            viewport={viewport}
          />
        </div>
      ))}
    </div>
  )
}

export default ImageGrid
